import { render, staticRenderFns } from "./LerMais.vue?vue&type=template&id=4b2c2d74&"
import script from "./LerMais.vue?vue&type=script&lang=js&"
export * from "./LerMais.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports